const handleClickSchedule = () => {
  const phoneNumber = "5547989129295";
  const message =
    "Olá! Eu vim do site e gostaria de saber mais sobre os tratamentos oferecidos.";

  window.open(
    `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
    "_blank",
  );
};

const handleScrollNavigation = (id: string, updateUrl = false) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    // Atualiza o hash na URL, para ativar o :target
    if (updateUrl) {
      window.history.pushState(null, "", `#${id}`);
    }
  }
};

export { handleClickSchedule, handleScrollNavigation };
